<template>
  <a-modal
    v-model:visible="visible"
    :title="`Empresas del holding ${holdingName}`"
    :footer="null"
    width="700px"
  >
    <a-table
      :data-source="companies"
      :columns="columns"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <template #actionRender="{ record }">
        <a-tooltip color="#05045D" title="Descargar stock">
          <a-button type="link" @click="downloadStock(record)">
            <download-outlined />
          </a-button>
        </a-tooltip>
        <a-button type="link" @click="goToStock(record)">Ver</a-button>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { DownloadOutlined } from '@ant-design/icons-vue';
import { Company } from '@/network';
import { DOWNLOAD_EXCEL_STOCK } from '@/store/types';
import rutHelper from '@/utils/Ruts';
import notification from '@/utils/notifications';

export default {
  name: 'HoldingCompaniesModal',
  components: {
    'download-outlined': DownloadOutlined
  },
  setup() {
    const store = useStore();

    const visible = ref(false);
    const loading = ref(false);
    const holdingName = ref('');
    const companies = ref([]);

    const columns = [
      {
        title: 'Empresa',
        dataIndex: 'businessName',
        key: 'businessName'
      },
      {
        title: 'RUT',
        dataIndex: 'rut',
        key: 'rut'
      },
      {
        title: 'Acción',
        key: 'action',
        align: 'center',
        width: 220,
        slots: {
          customRender: 'actionRender'
        }
      }
    ];

    const fetchCompanies = async (holdingId) => {
      loading.value = true;
      try {
        const resp = await Company({ holding: holdingId });
        companies.value = (resp.data || []).map((company) => ({
          ...company,
          rut: rutHelper.formatRut(company.rut)
        }));
      } catch (error) {
        notification(
          'error',
          'Error',
          error?.response?.data?.message ||
            'Ocurrió un error al obtener las empresas del holding.'
        );
      }
      loading.value = false;
    };

    const openModal = ({ id, holdingName: name }) => {
      holdingName.value = name;
      visible.value = true;
      fetchCompanies(id);
    };

    const downloadStock = async (company) => {
      const url = await store.dispatch(DOWNLOAD_EXCEL_STOCK, company.id);
      const cacheBustedUrl =
        `${url}${url.includes('?') ? '&' : '?'}` + `_ts=${Date.now()}`;
      window.open(cacheBustedUrl, '_blank');
    };

    const goToStock = (company) => {
      window.open(`/clientes/empresa/${company.id}/stock`, '_blank');
    };

    return {
      visible,
      loading,
      holdingName,
      companies,
      columns,
      openModal,
      downloadStock,
      goToStock
    };
  }
};
</script>
